import {
  Component,
  OnInit,
  EventEmitter,
  Input,
  Output,
  TemplateRef,
} from "@angular/core";
import { GItemDefiningViewModel } from "src/app/viewmodels/g-item/GItemDefiningViewModel";
import { JqHelper } from "src/app/common/jq-helper";
import { UnitOfWorkService } from "src/app/services/api/uow/unit-of-work.service";
import { BsModalService, BsModalRef } from "ngx-bootstrap/modal";
import { IDropdownSettings } from "ng-multiselect-dropdown";
import { ItemViewModel, ItemViewModel1 } from "src/app/viewmodels/ItemViewModel";
import { GPurchaseRequisitionViewModel } from "src/app/viewmodels/g-purchase/GPurchaseRequisitionViewModel";
import { G_PurchaseMasterViewModel } from "src/app/viewmodels/g-purchase/G_PurchaseMasterViewModel";
import { AccountDefiningModel, DefineAccountviewModel } from "src/app/viewmodels/g-customer/DefineAccountviewModel";
import Swal from "sweetalert2";
import { NgxSpinnerService } from "ngx-spinner";
import { G_WareHouseViewModel } from 'src/app/viewmodels/g-settings/G_Warehouse_Viewmodel';
import { LocalStorageService } from "src/app/services/common/local-storage.service";
import { PurchaseDetailViewModel } from "src/app/viewmodels/g-purchase/PurchaseDetailViewModel";
import { PurchaseDetailModel, SavePurchaseMasterRequest } from "src/app/viewmodels/g-purchase/GPurchaseViewModel";
import { SaveItemRequest } from "src/app/viewmodels/g-settings/GSettingViewModel";
import { AppConsts } from "src/app/common/app-consts";
import { E_G_EPSStatusType } from "src/app/viewmodels/g-purchase/E_G_EPSStatusType";

@Component({
  selector: "app-purchase-order-form",
  templateUrl: "./purchase-order-form.component.html",
  styleUrls: ["./purchase-order-form.component.scss"],
})
export class PurchaseOrderFormComponent implements OnInit {
  public client: any;
  public user: any;
  constructor(
    private _jq: JqHelper,
    private _uow: UnitOfWorkService,
    private _modalService: BsModalService,
    private spinner: NgxSpinnerService,
    private _localStorageService: LocalStorageService
  ) { }

  @Input() public vm: SavePurchaseMasterRequest;
  @Input() public modal_title: any;
  @Input() public bsmRef: BsModalRef;
  @Output() onSubmitted = new EventEmitter<any>();
  public component_Title = "Purchase Order";
  modalRef: BsModalRef;
  private submitted = false;
  public isPreview: boolean = false;
  public thumbnail: any;
  public ComName: any;
  public Address: any;
  public contect: any;

  public defaultDropdownSettings: IDropdownSettings = {
    singleSelection: true,
    idField: "id",
    textField: "refId",
    enableCheckAll: false,
    selectAllText: "Select All",
    unSelectAllText: "UnSelect All",
    itemsShowLimit: 3,
    allowSearchFilter: true,
  };
  public warehouseDropdownSettings: IDropdownSettings = {
    singleSelection: true,
    idField: "id",
    textField: "name",
    enableCheckAll: false,
    selectAllText: "Select All",
    unSelectAllText: "UnSelect All",
    itemsShowLimit: 3,
    allowSearchFilter: true,
  };

  public accountDropdownSettings: IDropdownSettings = {
    singleSelection: true,
    idField: "id",
    textField: "accTitle",
    enableCheckAll: false,
    selectAllText: "Select All",
    unSelectAllText: "UnSelect All",
    itemsShowLimit: 4,
    allowSearchFilter: true,
  };
  public itemsDropdownSettings: IDropdownSettings = {
    singleSelection: false,
    idField: "id",
    textField: "name",
    enableCheckAll: false,
    selectAllText: "Select All",
    unSelectAllText: "UnSelect All",
    itemsShowLimit: 3,
    allowSearchFilter: true,
  };

  public sparePartVm: SaveItemRequest = new SaveItemRequest();
  public citemtype = "itemtype";
  public itemTypes: any = [];

  public suppliers: any = [];
  public csuppliers = "suppliers";
  public selectedSuppliers: any = [];

  public spareParts: any = [];
  public selectedSpareParts: any = [];
  public selectspp: any;
  public purchaseRequisitions: any = [];
  public warehouseList: any = [];
  public cpurchaseRequisitions = "purchaseRequisitions";
  public selectedPurchaseRequisitions: any = [];
  public selectedWarehouse: any = [];
  name = "cpEmail";
  id = "id";
  checked = true;
  disabled = false;
  label = "Toggle On/Off";
  labelledby = "Some Other Text";

  public TotalPayable = 0;
  public TotalVat = 0;
  public TotalPayableAfterVat = 0;

  public itemType = new ItemViewModel1();
  ngOnInit() {
    debugger
    this.client = this._localStorageService.get("com");
    this.user = this._localStorageService.get("ussr");
    this.getimage();
    if (this.vm == undefined) {
      this.vm = new SavePurchaseMasterRequest();
      this.vm.transactionDate = new Date();
      this.vm.debitAcc = new ItemViewModel1();
      this.vm.supCreditAcc = new ItemViewModel1();
      this.vm.statusType = new ItemViewModel1();
      this.vm.tag = new ItemViewModel1();
      this.vm.supplier = new ItemViewModel1();
      this.vm.wareHouse = new ItemViewModel1();
      this.vm.purchaseDetail = [];
      this.selectedSpareParts = [];
      this.selectedPurchaseRequisitions = [];
      // this.selectedWarehouse = [];
      this.vm.supCreditAccEmail = new ItemViewModel1(0, "");
      this.getRefid();
    } else {
      let selectedSuplier: any = [];
      let selectedSaprePartsList: any = [];
      if (
        this.vm.supCreditAcc != undefined &&
        this.vm.supCreditAcc != null
      ) {
        let sCA = new AccountDefiningModel();
        sCA.id = this.vm.supCreditAcc.id;
        sCA.accTitle = this.vm.supCreditAcc.name;
        selectedSuplier.push(sCA);
        this.selectedSuppliers = selectedSuplier;
        this.vm.supCreditAcc = new ItemViewModel1(
          this.vm.supCreditAcc.id,
          this.vm.supCreditAcc.name
        );
      }
      this.vm.purchaseDetail.forEach((x) => {
        let partssSelected = new SaveItemRequest();
        partssSelected.id = x.item.id;
        partssSelected.name = x.item.name;
        selectedSaprePartsList.push(partssSelected);
      });
      this.selectedSpareParts = selectedSaprePartsList;
      this.updateTotals();
    }
    if (this.modal_title == undefined) {
      this.modal_title = "Purchase Order";
    }
    this.sparePartVm = new SaveItemRequest();
    this.sparePartVm.itemType = new ItemViewModel1(0, " ");

    this.getItemTypes();
    this.getSuppliers();
    this.getRequisitions();
    this.getSpareParts();
    this.getWarehouses();
  }

  onChange(e) {
    debugger;
    let item = this.selectspp;
    if (e == true) {
      if (this.selectedSuppliers.length > 0 && this.suppliers != undefined) {
        let findSelected = this.suppliers.find(
          (x) => x.id == this.selectedSuppliers[0].id
        );
        let i = new SavePurchaseMasterRequest();
        this.vm.supCreditAccEmail = new ItemViewModel1(
          findSelected.id,
          findSelected.cpEmail
        );
      }
      this.vm.isEmailRequired = true;
    } else {
      this.vm.supCreditAccEmail = null;
      this.vm.isEmailRequired = false;
    }
  }

  getRefid() {
    this._uow.gPurchaseService.GetGPurchaseRefIdAsync().subscribe(
      (res: any) => {
        console.log(res);
        this.vm.refId = res.code;
      },
      (error) => {
        console.log(error);
      }
    );
  }

  getimage() {

    this._uow.gSettingService.GetHeaderFootersDropDownAsync().subscribe((baseImage: any) => {
      console.log(baseImage);
      debugger;
      if (baseImage != undefined && baseImage !== null) {
        if (baseImage.attachment != undefined && baseImage.attachment !== null) {

          this.thumbnail = `https://fleetdesks.s3.eu-central-1.amazonaws.com/${baseImage.attachment}`;
          this.ComName = baseImage.compName;
          this.Address = baseImage.address;
          this.contect = baseImage.contact;
        } else {
          this.thumbnail = `https://fleetdesks.s3.eu-central-1.amazonaws.com/${baseImage.attachment}`;
          this.ComName = baseImage.compName;
          this.Address = baseImage.address;
          this.contect = baseImage.contact;
        }
      }
    }, (err) => {
      console.log(err);
    })
  }

  getItemTypes() {
    this._uow.gSettingService.GetItemTypesAsync().subscribe((res: any) => {
      this.itemTypes = res.result;
      console.log(res);
    }, (err) => this._uow.logger.log(err));
  }

  getSuppliers() {
    this._uow.gSettingService.GetGCustomersDropDownAsync(AppConsts.SUPPLIER).subscribe((res: any) => {

      this.suppliers = res.result;
      this._uow.logger.log(this.suppliers);
    }, (err) => this._uow.logger.log(err));
  }

  getWarehouses() {
    this._uow.gSettingService.GetUserWarehouseAsync(this.user.Id).subscribe(
      (res: any) => {
        debugger
        this.selectedWarehouse = res.result;
        this.warehouseList = res.result;
        console.log(this.selectedWarehouse);
      },
      (error) => {
        console.log(error);
      }
    );
  }

  getRequisitions() {
    this._uow.gSettingService.GetPurchaseRequisiteDropDownAsync().subscribe(
      (res: any) => {
        this.purchaseRequisitions = res.result;
      },
      (error) => {
        console.log(error);
      }
    );
  }

  getSpareParts() {
    //'Spare-Parts'
    this._uow.gSettingService.GetItemsDropDownByTypeAsync("Spare-Parts").subscribe(
      (res: any) => {
        this.spareParts = res.result;
        console.log(res);
      },
      (err) => {
        this._uow.logger.log(err);
        this.spareParts = [];
      }
    );
  }

  // spare parts
  onSelectSparePart(e) {
    console.log(e);
    if (
      this.vm.purchaseDetail == undefined ||
      this.vm.purchaseDetail.length == 0
    ) {
      this.vm.purchaseDetail = [];
    }
    let item = this.spareParts.find((x) => x.id === e.id);
    console.log(item);
    if (item !== undefined) {
      let i = new PurchaseDetailModel();
      i.quantity = 1;
      i.item = new ItemViewModel1(item.id, item.name);
      i.maxQuantity = item.maxStock;
      i.availabelQuantity = item.currentStock;
      i.quantity = item.maxStock - item.currentStock;
      if (item.currentStock > item.maxStock) {
        i.quantity = 0;
      }
      i.itemCode = item.code;
      i.itemName = item.name;
      i.purchasePrice = item.purchasePrice;
      i.salePrice = item.salePrice;
      i.itemType = item.itemType.name;

      this.quantityOrPriceChanged(i);
      this.vm.purchaseDetail.push(i);
      this.updateTotals();
    }
  }

  onDeSelectSparePart(e) {
    let i = this.vm.purchaseDetail.find((x) => x.item.id === e.id);
    if (i !== undefined) {
      this.vm.purchaseDetail.splice(this.vm.purchaseDetail.indexOf(i), 1);
    }
  }

  onSelectSupplier(e) {
    let item = this.suppliers.find((x) => x.id === e.id);
    console.log(item);
    if (item !== undefined) {
      let i = new SavePurchaseMasterRequest();
      this.vm.supCreditAcc = new ItemViewModel1(item.id, item.accTitle);
      this.selectspp = item;
      //this.vm.FK_Sup_Cradit_Acc.Id = item.Id;
      //this.vm.FK_Sup_Cradit_Acc.Name = item.Acc_Titel;
    }
  }

  // input changes
  quantityOrPriceChanged(m) {
    m.totalAmount = m.quantity * m.purchasePrice;
    this.updateTotals();
  }
  updateTotals() {
    this.TotalPayableAfterVat = 0;
    this.TotalVat = 0;
    this.TotalPayable = 0;
    if (
      this.vm.purchaseDetail !== undefined &&
      this.vm.purchaseDetail.length > 0
    ) {
      this.vm.purchaseDetail.forEach((x) => {
        this.TotalPayable += x.totalAmount;
        this.TotalPayableAfterVat += x.totalAmount;
        this.vm.invAmount = this.TotalPayableAfterVat;
      });
    }
  }

  // purchase requisition change
  onSelectPurchaseRequisition(e) {
    debugger
    let selectedSaprePartsList: any = [];
    let selectedWareHouseList: any = [];
    let selectedSuplier: any = [];
    let selectemail: any = [];
    let f = this.purchaseRequisitions.find((x) => x.id == e.id);
    if (f !== undefined) {
      console.log("purchase", f);
      let s = f;
      //this.vm = new G_PurchaseMasterViewModel();
      this.vm = s;
      this.vm.wareHouse = new ItemViewModel1(s.wareHouse.id, s.wareHouse.name);
      this.vm.isLinked = true;
      this.vm.invAmount = this.TotalPayableAfterVat;
      this.vm.transactionDate = this._uow.defaultService.CutTimeZone(
        f.transactionDate
      );

      if (s.wareHouse != null && s.wareHouse != undefined) {
        this.vm.wareHouse = new ItemViewModel1(s.wareHouse.id, s.wareHouse.name);
        
        selectedWareHouseList.push({ wareHouse: this.vm.wareHouse });

        this.selectedWarehouse = selectedWareHouseList;
        console.log(this.selectedWarehouse);
      }

      if (f.supCreditAcc != undefined && f.supCreditAcc != null) {
        let sCA = new AccountDefiningModel();
        sCA.id = f.supCreditAcc.id;
        sCA.accTitle = f.supCreditAcc.name;
        selectedSuplier.push(sCA);
        this.selectedSuppliers = selectedSuplier;
        this.vm.supCreditAcc = new ItemViewModel1(
          f.supCreditAcc.id,
          f.supCreditAcc.name
        );
      }

      if (
        f.supCreditAccEmail != undefined &&
        f.supCreditAccEmail != null
      ) {
        let sCA = new AccountDefiningModel();
        sCA.id = f.supCreditAccEmail.id;
        sCA.cpEmail = f.supCreditAccEmail.name;
        selectemail.push(sCA);
        this.selectspp = selectemail;
        this.vm.supCreditAccEmail = new ItemViewModel1(
          f.supCreditAccEmail.id,
          f.supCreditAccEmail.name
        );
      }
      debugger
      if (
        this.vm.purchaseDetail !== undefined &&
        this.vm.purchaseDetail.length > 0
      ) {
        this.vm.purchaseDetail.forEach((x) => {
          x.totalAmount = x.quantity * x.purchasePrice;
          let partssSelected = new SaveItemRequest();
          partssSelected.id = x.item.id;
          partssSelected.name = x.item.name;
          selectedSaprePartsList.push(partssSelected);
        });
        this.selectedSpareParts = selectedSaprePartsList;
        this.updateTotals();
      }
    }
  }

  onDeSelectPurchaseRequisition(e) {
    this.selectedSpareParts = [];
    this.selectedSuppliers = [];
    this.selectedWarehouse = this.warehouseList;
    // let f = this.purchaseRequisitions.find(x => x.Id == e.Id);
    // if (f !== undefined) {
    //   this.vm = new G_PurchaseMasterViewModel();
    // }
    if (this.selectedPurchaseRequisitions.length == 0) {
      this.vm = new SavePurchaseMasterRequest();
      this.vm.transactionDate = new Date();
      this.getRefid();
      this.updateTotals();
    }
  }

  onRemoveFromDetailList(e) {
    this.selectedSpareParts = [];
    console.log(e);
    let i = this.vm.purchaseDetail.find(
      (x) => x.item.id === e.item.id
    );
    if (i !== undefined) {
      this.vm.purchaseDetail.splice(this.vm.purchaseDetail.indexOf(i), 1);
      this.vm.purchaseDetail.forEach((x) => {
        this.selectedSpareParts.push(
          new ItemViewModel1(x.item.id, x.item.name)
        );
      });
      if (this.vm.purchaseDetail.length == 0) {
        this.selectedPurchaseRequisitions = [];
        this.getRefid();
      }
    }

    this.getRequisitions();
  }



  // exteral coponents
  openModal(template: TemplateRef<any>, lvl: number = 1) {
    if (lvl == 1) {
      this.modalRef = this._modalService.show(template);
    }
    // if (lvl == 2) {
    //   this.modalRefLv2 = this._modalService.show(template);
    // }
  }
  compareFn(optionOne, optionTwo): boolean {
    if (optionOne !== undefined && optionTwo !== undefined) {
      return optionOne.id === optionTwo.id;
    }
  }
  openSaveOrUpdateModel(template: TemplateRef<any>, model?) {
    if (model !== undefined) {
      this.sparePartVm = model;
    } else {
      this.sparePartVm = undefined;
    }
    this.openModal(template, 1);
    this.modalRef.setClass("modal-xl");
  }
  openSaveOrUpdateModelForItemType(
    template: TemplateRef<any>,
    model?,
    itemType?
  ) {
    this.itemType = this.itemTypes[itemType];
    this.sparePartVm.itemType = new ItemViewModel1(
      this.itemType.id,
      this.itemType.name
    );
    // this.sparePartVm.FK_G_ItemType_Id = new ItemViewModel(this.itemType.Id, this.itemType.Name);
    console.log(this.itemTypes);
    this.openSaveOrUpdateModel(template, model);
  }

  saveOrUpdate() {
    debugger;
    // this._jq.showSpinner(true);
    this.spinner.show();
    this.onChange(true);
    this.vm.statusType = new ItemViewModel1(E_G_EPSStatusType.Purchase_Order)
    this._uow.gPurchaseService
      .SaveGPurchaseAsync(this.vm)
      .toPromise()
      .then((res: any) => {
        console.log(res);
        this.submitted = true;
        this.vm.isEmailRequired = true;
        //this.vm = res;
        this.bsmRef.hide();
        //this.modalRef.hide();
        this.onSubmitted.emit(this.submitted);
        this.spinner.hide();
        Swal.fire("Created!", "Created/Updated! Successfully", "success");
        // this._jq.showSpinner();
      })
      .catch((error) => {
        Swal.fire("Failure!", error.error.message, "error");
        console.log(`Promise rejected with ${JSON.stringify(error)}`);
        this.onSubmitted.emit(this.submitted);
        // this._jq.showSpinner();
        this.spinner.hide();
      });
  }

  navigateClick() {
    this.isPreview = false;
    this.modalRef.hide();
  }

  // external components
  onItemSubmitted(e, mf) {
    this._uow.logger.log(e);
    if (e === true) {
    }
  }

  openPreview(content) {
    this.modalRef = this._uow.modalServiceEx.show(content);
    this.modalRef.setClass("modal-lg");
    this.isPreview = true;
  }

   closeModal() {
    this.bsmRef.hide();
    this.onSubmitted.emit(true); // Emit event to refresh list
  }
}
